import { FontAwesome } from '@expo/vector-icons';
import { COMMON_CONSTANTS } from '@root/constants';
import colors from '@theme/colors';
import AmplitudeHelper from '@utils/analytics';
import { AMPLITUDE_CONSTANTS, AMPLITUDE_EVENT_SOURCES } from '@utils/analytics/constants';
import { scale } from '@utils/normalize';
import { Button, Icon, Text } from 'native-base';
import PropTypes from 'prop-types';
import React from 'react';
import { Linking } from 'react-native';
import styles from './styles';

function contactSupport() {
  const e = AMPLITUDE_CONSTANTS.authentication.help_clicked;
  AmplitudeHelper.logEvent(e.name, {
    [e.attributes.source]: AMPLITUDE_EVENT_SOURCES.login_page_source.login_page,
  });
  Linking.openURL(COMMON_CONSTANTS.support);
}

function BtnWhatsappContact(props) {
  const { t } = props;
  return (
    <Button
      testID="btnOpenWA"
      sentry-label="btnOpenWA"
      variant="ghost"
      flexDirection="row"
      borderWidth="1px"
      marginTop="24px"
      marginBottom="12px"
      borderColor={colors.disabled.smoke}
      borderRadius={scale(12)}
      style={styles.btnWhatsappStyles}
      onPress={() => contactSupport()}
      leftIcon={
        <Icon
          as={FontAwesome}
          name="whatsapp"
          color={colors.neutral.charcoal}
          fontSize={scale(18)}
          marginBottom="2px"
        />
      }>
      <Text testID="txtLoginHelp" variant="sm-bold" fontWeight="700">
        {t('login.help')}
      </Text>
    </Button>
  );
}

BtnWhatsappContact.propTypes = {
  t: PropTypes.func,
};
BtnWhatsappContact.defaultProps = {
  t: () => {},
};

export default BtnWhatsappContact;
